import { RoleData, UserData, UserOrganizerData } from 'src/@types/user';

export const disabledCompanyDataMenu = (params: {
  organizer: UserOrganizerData | null;
  role: RoleData | null;
  user: UserData | null;
}) => {
  const { organizer, role, user } = params;

  if (!!organizer) {
    if (role?.isOrganizer) {
      return false;
    }

    return !!user?.invited;
  } else {
    return !!user?.invited;
  }
};
